//
import CustomerModel from '@/models/Sale/SlCustomer'

/**
 * { item_description }
 */
export default async customer_id => {
  try {
    const customers = await CustomerModel
      .append('branch_offices', 'discount')
      .include('sl_ground_seller.hr_employee', 'pch_payment_condition', 'branch_offices.sl_customer_ground_seller.sl_ground_seller.hr_employee')
      .find(customer_id)
    return customers
  } catch (error) {
    return error.response.data
  }
}
